<template>
  <div class="prompt">
    <div class="prompt-card">
      <img src="@/assets/success.png" height="125" width="125">
      <h3>Successful</h3>
      <p v-html="message"></p>
      <button class="btn-success btn" @click="close">Close</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message'],
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>

</style>
